import { render } from "./text1.vue?vue&type=template&id=17c9e1ce&scoped=true"
import script from "./text1.vue?vue&type=script&lang=js"
export * from "./text1.vue?vue&type=script&lang=js"

import "./text1.vue?vue&type=style&index=0&id=17c9e1ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c9e1ce"]])

export default __exports__